import { render, staticRenderFns } from "./export-member.vue?vue&type=template&id=6987c993&scoped=true"
import script from "./export-member.vue?vue&type=script&lang=js"
export * from "./export-member.vue?vue&type=script&lang=js"
import style0 from "./export-member.vue?vue&type=style&index=0&id=6987c993&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987c993",
  null
  
)

export default component.exports